/**
 * Scrollable training material reader with readable line length.
 *
 * @param text - Plaintext training excerpt (**API or fixture**; not auto-translated).
 * @returns **`div.qz-reader`** suitable for embedding under participant routes.
 */
export function createTrainingReader(text: string): HTMLDivElement {
  const el = document.createElement("div");
  el.className = "qz-reader";
  el.tabIndex = 0;
  el.textContent = text;
  return el;
}
